<div class="iq-wrap">
  @if ( completedAt) {

  <div class="my-2">
    {{
      "registrationWizard.completionTimestamp"
        | translate : { date: (completedAt | date : dateFormatLong) }
    }}
  </div>
  <hr class="sub-divider my-2" />
  } @if (title && title.trim()) {
  <div class="iq-header">
    <h3 class="iq-title">{{ title | translate }}</h3>
  </div>
  }

  <div class="iq-list">
    <div class="iq-row" *ngFor="let it of items; trackBy: trackById">
      <span class="iq-label">{{ it.labelKey | translate }}</span>

      <span class="badge" [ngClass]="boolBadge.badgeClass(boolToKey(it.value))">
        {{ boolBadge.labelKey(boolToKey(it.value)) ?? "" | translate }}
      </span>
    </div>
  </div>
</div>
